export const styles = {
  dropdown: {
    width: "10%",
    margin: "0.5%",
  },
  selection: {
    maxHeight: 148,
    overflowY: "scroll",
  },
  linkedName: {
    cursor: "pointer",
    fontWeight: "bold",
  },
  searchBox: {
    width: "20%",
    marginLeft: "auto",
    marginRight: "1em",
  },
  searchArea: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  tableToolBar: {
    marginLeft: "2em",
    marginBottom: "1em",
  },
  rightActionButton: {
    marginLeft: "1em",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "0.5em",
    paddingTop: "1em",
  },
  firstButton: {
    height: "40px",
    marginTop: "0.6em",
    marginLeft: "0.6em",
  },
  actionButton: {
    height: "40px",
    marginTop: "0.6em",
    marginLeft: "1em",
  },
  table: {
    fontSize: 16,
    height: "65vh",
  },
};
